import React, { useState } from "react";
import Dialog from '@mui/material/Dialog';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const MedicationHistoryDialog = (props) => {
    const [state, setState] = useState({
        drugName: "",
        dose: "",
        startDate: null,
        endDate: null,
        response: "",
        submitError: false
    });

    const submitData = () => {
        if (state.drugName === '' || state.drugName.trim() === '' || state.dose === '' || state.dose.trim() === '' || state.response === '' || state.response.trim() === '' || !state.startDate || !state.endDate) {
            setState({ ...state, submitError: true });
        } else {
            const data = state;
            delete data.submitError;
            props.handleClose(state);
            setState({ ...state, submitError: false });
        }
    }

    const popperProps = {
        positionFixed: true
    }

    return <Dialog disableEscapeKeyDown={true} open={props.open} onClose={(e, reason) => {
        if (reason !== 'backdropClick') {
            props.handleClose(e);
        }
    }}>
        <div className="dialog">
            <div className="dialog__header">MEDICATION HISTORY</div>
            <div className="dialog__heading">
                Drug Name
            </div>
            <input className={`w-100 input ${state.submitError && (state.drugName === '' || state.drugName.trim() === '') && 'error-border'}`} value={state.drugName} onChange={e => setState({ ...state, drugName: e.target.value })} />
            <div className="dialog__heading">
                Dose
            </div>
            <input className={`w-100 input ${state.submitError && (state.dose === '' || state.dose.trim() === '') && 'error-border'}`} value={state.dose} onChange={e => setState({ ...state, dose: e.target.value })} />
            <div className="dialog__dates">
                <div className="d-grid">
                    <div className="dialog__heading">
                        Start Date:
                    </div>
                    <DatePicker className={(state.submitError && !state.startDate) && 'error-border'} maxDate={state.endDate} popperProps={popperProps} dateFormat="dd/MM/yyyy" selected={state.startDate} onChange={date => setState({ ...state, startDate: date })} />
                </div>
                <div className="d-grid">
                    <div className="dialog__heading">
                        End Date:
                    </div>
                    <DatePicker className={(state.submitError && !state.endDate) && 'error-border'} minDate={state.startDate} popperProps={popperProps} dateFormat="dd/MM/yyyy" selected={state.endDate} onChange={date => setState({ ...state, endDate: date })} />
                </div>
            </div>
            <div className="dialog__heading">
                Response
            </div>
            <input className={`w-100 input ${state.submitError && (state.response === '' || state.response.trim() === '') && 'error-border'}`} value={state.response} onChange={e => setState({ ...state, response: e.target.value })} />
            <div className="d-grid buttons justify-content-around">
                <button className="btn secondary-button" onClick={() => props.handleClose('cancel')}>Cancel</button>
                <button className="btn primary-button" onClick={submitData}>Submit</button>
            </div>
        </div>
    </Dialog>;
}

export default MedicationHistoryDialog;